import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';
import CompanyListPanel from './CompanyListPanel';

function TaxPage({showToast,user}){
  var now=new Date();var defMonth=now.getFullYear()+'-'+('0'+(now.getMonth()+1)).slice(-2);
  var[yearMonth,setYearMonth]=useState(defMonth);
  var[taxData,setTaxData]=useState(null);
  var[loading,setLoading]=useState(false);
  var[checkedIds,setCheckedIds]=useState([]);
  var[sending,setSending]=useState(false);
  var[taxEmail,setTaxEmail]=useState('');
  var[sendWarnings,setSendWarnings]=useState([]);
  // 2026-05-22 — 강제 전송 시 sendType 기억 (1차 시도 → 1차 강제 / 최종 시도 → 최종 강제)
  var[lastSendType,setLastSendType]=useState('full');
  var isAdmin=user&&(user.role==='관리자'||user.role==='admin');
  var isDocAgency=user&&user.role==='doc_agency';
  var showCompanyFilter=isAdmin||isDocAgency;
  var[companies,setCompanies]=useState([]);
  var[filterCompanyId,setFilterCompanyId]=useState('');
  var[zipLoading,setZipLoading]=useState(false);
  // 2026-05-26 — ZIP/메일 폴더 구조: 'car'(차량별) | 'docType'(서류 종류별). 세무사 요청. 선택 영속화.
  var[zipGroupBy,setZipGroupBy]=useState(localStorage.getItem('autodoc_tax_zip_groupby')||'car');
  var changeGroupBy=function(e){var v=e.target.value;localStorage.setItem('autodoc_tax_zip_groupby',v);setZipGroupBy(v);};

  var monthOptions=(function(){var a=[];for(var i=0;i<24;i++){var d=new Date(now.getFullYear(),now.getMonth()-i,1);a.push(d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2));}return a;})();

  useEffect(function(){if(isAdmin&&!isDocAgency){authFetch(API+'/admin/companies').then(function(r){return r.json()}).then(function(d){setCompanies(d||[])}).catch(function(){})}},[]);

  var loadTax=function(){setLoading(true);var url=API+'/tax/'+yearMonth;if(showCompanyFilter&&filterCompanyId)url+='?companyId='+filterCompanyId;authFetch(url).then(function(r){return r.json()}).then(function(d){setTaxData(d);setLoading(false);setCheckedIds([])}).catch(function(){setLoading(false)})};
  useEffect(function(){loadTax()},[yearMonth,filterCompanyId]);

  var cars=taxData?taxData.cars:[];
  var toggleCheck=function(id){setCheckedIds(function(p){return p.includes(id)?p.filter(function(x){return x!==id}):p.concat([id])})};

  // 서류 업로드 (범용)
  var uploadDoc=function(carId,docType){
    var inp=document.createElement('input');inp.type='file';inp.accept='image/*,.pdf';
    inp.onchange=function(){var f=inp.files[0];if(!f)return;var fd=new FormData();fd.append('file',f);fd.append('docType',docType);
      authFetch(API+'/cars/'+carId+'/upload-doc',{method:'POST',body:fd}).then(function(r){return r.json()}).then(function(d){if(d.success){showToast('업로드 완료');loadTax()}else{showToast('업로드 실패','err')}}).catch(function(){showToast('서버 오류','err')});
    };inp.click();
  };

  // 서류 다운로드 — CarList.downloadServerDoc 와 동일 패턴 (#116 후 {docType}_{carNo} 네이밍 + 인증 다운로드)
  var downloadDoc=function(carId,docType){
    authFetch(API+'/cars/'+carId+'/docs').then(function(r){return r.json()}).then(function(docs){
      // 새 파일명({docType}_{carNo}.ext) 호환 — exact 매칭 대신 prefix 매칭
      var found=(docs||[]).find(function(d){var b=(d.fileName||'').split('.')[0];return b===docType||b.startsWith(docType+'_')});
      if(!found){showToast('파일 없음','err');return;}
      // 비-REALTIME 캐시서류: 200 JSON {url} → 상대경로는 authFetch blob(인증게이트 통과), 절대URL은 직링크.
      // REALTIME(malso/contract/nonbiz/pumui): 즉석 PDF buffer → blob.
      authFetch(API+'/cars/'+carId+'/docs/'+found.fileName).then(function(r2){
        var ct=(r2.headers&&r2.headers.get&&r2.headers.get('content-type'))||'';
        if(ct.indexOf('application/json')!==-1){
          return r2.json().then(function(j){
            if(!j||!j.url)return;
            if(j.url.charAt(0)==='/'){
              return authFetch(j.url).then(function(r3){return r3.blob()}).then(function(blob){var u=URL.createObjectURL(blob);var a=document.createElement('a');a.href=u;a.download=j.filename||found.fileName;a.click();URL.revokeObjectURL(u)});
            }
            var a=document.createElement('a');a.href=j.url;a.download=j.filename||found.fileName;a.click();
          });
        }
        return r2.blob().then(function(blob){var u=URL.createObjectURL(blob);var a=document.createElement('a');a.href=u;a.download=found.fileName;a.click();URL.revokeObjectURL(u)});
      }).catch(function(){showToast('다운로드 실패','err')});
    }).catch(function(){showToast('서버 오류','err')});
  };

  // 세무사 이메일 전송 (sendType: 'first' | 'full')
  var sendTax=async function(sendType,force){
    if(!taxEmail){showToast('세무사 이메일을 입력하세요','err');return;}
    var ids=(checkedIds.length?checkedIds:cars.map(function(c){return c.id})).filter(function(id){var c=cars.find(function(x){return x.id===id});return !(c&&isScrapExcl(c));}); // 폐차 제외
    if(!ids.length){showToast('전송할 차량이 없습니다','err');return;}
    // 2026-05-22 — 강제 전송 시 sendType 보존 (force 가 아닐 때만 갱신)
    if(!force)setLastSendType(sendType);
    setSending(true);setSendWarnings([]);
    try{
      var resp=await authFetch(API+'/tax/send',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({month:yearMonth,toEmail:taxEmail,carIds:ids,force:!!force,sendType:sendType,groupBy:zipGroupBy})});
      var d=await resp.json();
      setSending(false);
      if(d.warnings&&d.warnings.length>0&&!d.success){setSendWarnings(d.warnings);showToast('누락 서류가 있습니다','err');return;}
      if(d.success){showToast((sendType==='first'?'1차 환급신청':'최종 서류')+' 전송 완료 (첨부 '+d.attachments+'건)');setSendWarnings([]);}
      else{showToast('전송 실패: '+(d.error||''),'err');}
    }catch(e){setSending(false);showToast('서버 오류','err');}
  };

  // ZIP 다운로드 — 5분 TTL 토큰 선발급 → <a href=...?token=...> native streaming
  // (blob 방식은 응답 전체 수신까지 대기하여 progressive download 차단 → 체감 느림.
  //  토큰 쿼리 파라미터로 인증 유지하며 브라우저 다운로드 매니저에 위임.)
  var downloadZip=function(){
    if(zipLoading)return;
    setZipLoading(true);
    var body={month:yearMonth};
    if(showCompanyFilter&&filterCompanyId)body.companyId=filterCompanyId;
    authFetch(API+'/tax/download-zip-token',{method:'POST',body:JSON.stringify(body)}).then(function(r){
      if(!r.ok)return r.json().then(function(j){throw new Error(j&&j.error?j.error:'토큰 발급 실패')});
      return r.json();
    }).then(function(d){
      if(!d||!d.token)throw new Error('토큰 없음');
      var zipUrl=API+'/tax/download-zip/'+yearMonth+'?token='+encodeURIComponent(d.token);
      if(showCompanyFilter&&filterCompanyId)zipUrl+='&companyId='+encodeURIComponent(filterCompanyId);
      zipUrl+='&groupBy='+encodeURIComponent(zipGroupBy);
      var a=document.createElement('a');a.href=zipUrl;a.download='tax_'+yearMonth+'.zip';a.click();
      setZipLoading(false);
    }).catch(function(e){showToast(e.message||'서버 오류','err');setZipLoading(false)});
  };

  // 폐차로 세무(환급/신고) 제외 판정 — 업체(세금계산서)=실제폐차(scrapDisposed), 개인(의제)=폐차장매입 포함(scrapExcluded).
  // 제외 차량은 흐리게+'폐차제외' 뱃지, 서류 충족 셀 숨김('-'), 세무사 전송 대상에서 배제.
  var isScrapExcl=function(c){var pt=c.purchaseType||'individual';var needTax=pt==='business'||pt==='individual_biz_tax';return needTax?!!c.scrapDisposed:!!c.scrapExcluded;};
  // 서류 상태 셀
  var docCell=function(carId,docType,has,skip){
    if(skip) return(<td style={{textAlign:'center',color:'#94a3b8',fontSize:11}}>-</td>);
    if(has) return(<td style={{textAlign:'center',cursor:'pointer'}} onClick={function(){downloadDoc(carId,docType)}}><span style={{color:'#16a34a',fontWeight:700,fontSize:13}}>✓</span></td>);
    return(<td style={{textAlign:'center',cursor:'pointer'}} onClick={function(){uploadDoc(carId,docType)}}><span style={{color:'#dc2626',fontWeight:700,fontSize:13}}>✗</span></td>);
  };

  // 상태 배지
  var statusBadge=function(c){
    if(c.complete) return(<span style={{padding:'2px 8px',borderRadius:4,fontSize:10,fontWeight:700,background:'#dcfce7',color:'#166534'}}>완료</span>);
    if(c.isCarryOver) return(<span style={{padding:'2px 8px',borderRadius:4,fontSize:10,fontWeight:700,background:'#dbeafe',color:'#1e40af'}}>이월</span>);
    return(<span style={{padding:'2px 8px',borderRadius:4,fontSize:10,fontWeight:700,background:'#fef2f2',color:'#dc2626'}}>미비</span>);
  };

  return(<div style={{display:'flex',gap:16}}>
    {showCompanyFilter&&<CompanyListPanel user={user} context="tax" month={yearMonth} selectedCompanyId={filterCompanyId} onSelect={function(id){setFilterCompanyId(id)}} onSwitch={function(cid){authFetch(API+'/auth/switch-company',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({companyId:cid})}).then(function(r){return r.json()}).then(function(d){if(d.success&&d.token){localStorage.setItem('autodoc_token',d.token);sessionStorage.setItem('autodoc_user',JSON.stringify(d.user));window.location.reload()}}).catch(function(){})}}/>}
    <div style={{flex:1,minWidth:0}}>
    {/* 상단 월 선택 */}
    <div style={{display:'flex',gap:8,marginBottom:16,alignItems:'center',flexWrap:'wrap'}}>
      <select style={{padding:8,border:'1px solid #d0d5dd',borderRadius:8,fontWeight:700,fontSize:14}} value={yearMonth} onChange={function(e){setYearMonth(e.target.value)}}>
        {monthOptions.map(function(ym){return(<option key={ym} value={ym}>{ym}</option>)})}
      </select>
      {isAdmin&&<select style={{padding:8,border:'1px solid #d0d5dd',borderRadius:8,fontSize:13,color:'#1B3A5C',fontWeight:600}} value={filterCompanyId} onChange={function(e){setFilterCompanyId(e.target.value)}}>
        <option value="">전체 업체</option>
        {companies.map(function(c){return(<option key={c.id} value={c.id}>{c.name}</option>)})}
      </select>}
      <button className="btn btn-blue btn-sm" onClick={loadTax} disabled={loading}>{loading?'...':'새로고침'}</button>
      <span style={{display:'flex',alignItems:'center',gap:4,fontSize:12,color:'#64748b'}} title="ZIP 다운로드 및 세무사 메일 전송 시 폴더 구조">
        <span>폴더</span>
        <select style={{padding:'6px 8px',border:'1px solid #d0d5dd',borderRadius:8,fontSize:12,fontWeight:600,color:'#1B3A5C'}} value={zipGroupBy} onChange={changeGroupBy}>
          <option value="car">차량별</option>
          <option value="docType">서류 종류별</option>
        </select>
      </span>
      <button className="btn btn-sm" style={{background:zipLoading?'#94a3b8':'#475569',color:'#fff',border:'none',cursor:zipLoading?'wait':'pointer'}} onClick={downloadZip} disabled={zipLoading}>{zipLoading?'다운로드 준비 중...':'ZIP 다운로드'}</button>
    </div>

    {taxData&&(<>
      {/* 요약 통계 - 5칸 (#197 1차 완료 카드 제거) */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(5,1fr)',gap:12,marginBottom:16}}>
        <div className="stat-card"><div className="stat-info"><div className="stat-number">{taxData.total}</div><div className="stat-label">총 차량</div></div></div>
        <div className="stat-card"><div className="stat-info"><div className="stat-number" style={{color:'#16a34a'}}>{taxData.completeCount}</div><div className="stat-label">서류 완비</div></div></div>
        <div className="stat-card"><div className="stat-info"><div className="stat-number" style={{color:'#1e40af'}}>{taxData.carryOverCount||0}</div><div className="stat-label">이월</div></div></div>
        <div className="stat-card"><div className="stat-info"><div className="stat-number" style={{color:'#dc2626'}}>{taxData.missingCount}</div><div className="stat-label">서류 미비</div></div></div>
        <div className="stat-card"><div className="stat-info"><div className="stat-number" style={{color:'#2563eb'}}>{(taxData.estimatedRefund||0).toLocaleString()}</div><div className="stat-label">예상 환급액</div></div></div>
      </div>

      {/* 차량별 서류 현황 테이블 */}
      <div className="card" style={{padding:10,marginBottom:16,overflowX:'auto'}}>
        <table className="data-table" style={{minWidth:900}}>
          <thead><tr>
            <th style={{width:28}}><input type="checkbox" checked={checkedIds.length===cars.filter(function(c){return !isScrapExcl(c)}).length&&cars.some(function(c){return !isScrapExcl(c)})} onChange={function(e){if(e.target.checked){setCheckedIds(cars.filter(function(c){return !isScrapExcl(c)}).map(function(c){return c.id}))}else{setCheckedIds([])}}}/></th>
            <th>차량번호</th><th style={{fontSize:10}}>차대번호</th><th>매입가</th><th style={{fontSize:11}}>명의자 지급</th>
            <th style={{textAlign:'center',fontSize:11}}>매매계약서</th>
            <th style={{textAlign:'center',fontSize:11}}>말소증</th>
            <th style={{textAlign:'center',fontSize:11}}>세금계산서</th>
            <th style={{textAlign:'center',fontSize:11}}>비사업용</th>
            <th style={{textAlign:'center',fontSize:11}}>수출신고필증</th>
            <th style={{textAlign:'center',fontSize:11}}>구매확인서</th>
            <th style={{textAlign:'center',width:70}}>상태</th>
          </tr></thead>
          <tbody>
            {cars.map(function(c){
              var pt=c.purchaseType||'individual';
              var needTax=pt==='business'||pt==='individual_biz_tax';
              var needNonbiz=pt==='individual_biz';
              var scrapX=isScrapExcl(c); // 폐차 → 환급 제외
              var bg=scrapX?'#f8fafc':(c.complete?'#f0fdf4':c.isCarryOver?'#eff6ff':'transparent');
              return(<tr key={c.id} style={{background:bg,opacity:scrapX?0.55:1}}>
                <td style={{textAlign:'center'}}><input type="checkbox" checked={checkedIds.includes(c.id)} disabled={scrapX} onChange={function(){toggleCheck(c.id)}}/></td>
                <td style={{fontWeight:700}}>{c.carNo||'-'}</td>
                <td className="mono" style={{fontSize:10}}>{(c.vin||'').substring(0,12)}...</td>
                <td style={{textAlign:'right'}}>{(c.buyPrice||0).toLocaleString()}</td>
                <td style={{textAlign:'right',color:'#2563eb'}}>{(c.ownerPayment||0).toLocaleString()}</td>
                {docCell(c.id,'contract',c.docs.contract,scrapX)}
                {docCell(c.id,'malsoCert',c.docs.malsoCert,scrapX)}
                {docCell(c.id,'tax_invoice',c.docs.tax_invoice,scrapX||!needTax)}
                {docCell(c.id,'nonbiz',c.docs.nonbiz,scrapX||!needNonbiz)}
                {docCell(c.id,'export_declaration',c.docs.export_declaration,scrapX||(!c.docs.export_declaration&&c.docs.purchase_confirm))}
                {docCell(c.id,'purchase_confirm',c.docs.purchase_confirm,scrapX||(!c.docs.purchase_confirm&&c.docs.export_declaration))}
                <td style={{textAlign:'center'}}>{scrapX?(<span style={{padding:'2px 8px',borderRadius:4,fontSize:10,fontWeight:700,background:'#fee2e2',color:'#dc2626'}}>폐차제외</span>):statusBadge(c)}</td>
              </tr>);
            })}
          </tbody>
        </table>
      </div>

      {/* 하단: 일괄 전송 */}
      <div className="card" style={{padding:16}}>
        <div style={{display:'flex',gap:8,alignItems:'center',flexWrap:'wrap',marginBottom:10}}>
          <button className="btn btn-sm btn-outline" onClick={function(){setCheckedIds(cars.filter(function(c){return c.complete&&!isScrapExcl(c)}).map(function(c){return c.id}))}}>최종 완비만 선택</button>
          <span style={{fontSize:12,color:'#64748b'}}>{checkedIds.length}대 선택됨</span>
        </div>
        <div style={{display:'flex',gap:8,alignItems:'center',marginBottom:8}}>
          <input style={{flex:1,padding:8,border:'1px solid #d0d5dd',borderRadius:8,fontSize:12}} value={taxEmail} onChange={function(e){setTaxEmail(e.target.value)}} placeholder="세무사 이메일" type="email"/>
        </div>
        <div style={{display:'flex',gap:8}}>
          <button className="btn btn-blue" style={{flex:1,padding:10,borderRadius:8,fontSize:13,fontWeight:700}} onClick={function(){sendTax('full',false)}} disabled={sending}>
            {sending?'전송 중...':'최종 서류 전송'}
          </button>
        </div>
        <div style={{fontSize:11,color:'#94a3b8',marginTop:6}}>필수 서류: 매매계약서+말소증 (+ 업체 세금계산서) + 수출신고필증 또는 구매확인서</div>
        {sendWarnings.length>0&&(<div style={{background:'#fef2f2',padding:10,borderRadius:8,marginTop:10,fontSize:11,color:'#dc2626'}}>
          <b>누락 서류:</b><br/>{sendWarnings.map(function(w,i){return(<div key={i}>- {w}</div>)})}
          <div style={{fontSize:10,color:'#92400e',marginTop:6}}>{lastSendType==='first'?'※ 1차 환급신청':'※ 최종 서류'}로 시도했습니다. 그래도 보낼까요?</div>
          <button className="btn btn-sm" style={{marginTop:8,background:'#dc2626',color:'#fff',border:'none',padding:'8px 14px',borderRadius:6,fontWeight:700,cursor:'pointer'}} onClick={function(){sendTax(lastSendType,true)}}>경고 무시하고 강제 전송 ({lastSendType==='first'?'1차':'최종'})</button>
        </div>)}
      </div>
    </>)}
  </div></div>);
}

export default TaxPage;
